export default __webpack_public_path__ + "static/media/LogoTraining.892581dd.svg";